import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const WeeklyDigestComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "WeeklyDigestPage" */ "@circle-react/components/SettingsApp/WeeklyDigest"
    ),
);

export const WeeklyDigestPage = () => (
  <Suspense fallback={<PageLoader />}>
    <WeeklyDigestComponent />
  </Suspense>
);
